/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description ListingStatus
 */

export enum ListingStatus {
  /** what is this? */
  UNKNOWN = 0,
  ACTIVE = 1,
  DRAFT = 2,
  ARCHIVED = 3,
  LEASED = 4,
  DELETED = 5,
  WITHDRAWN = 6,
  FETCHING_MEDIA = 7,
  MODERATION = 8,
  PENDING = 9,
  DUPLICATE = 10,
  /** manual removal */
  BANNED = 11,
  SPAM = 12,
  HONEYPOT = 13,
  FOR_SALE = 14,
  /** like ACTIVE, but not available in search results */
  PRIVATE = 15,
}

Object.defineProperty(ListingStatus, '__ENUM_NAME', {
  value: 'ListingStatus',
  writable: false,
  configurable: false,
  enumerable: false,
})
